module.exports = __webpack_public_path__ + "assets/img/sentimentAnalysis.b45b2411.png";